zE('webWidget', 'setLocale', 'pt-br');
window.zESettings = {
  webWidget: {
    helpCenter: {
      chat: {
        connectOnPageLoad: false
      },
      filter: {
        section: '360011342312'
      }
    }
  }
};
